export default "__VITE_ASSET__CfsURVAX__"